import { Button, ConfigProvider, Space, Table } from 'antd';
import Icon, {CloseOutlined, CheckOutlined} from '@ant-design/icons';


import ExternalLink from '@Components/icons/ExternalLink';

import { getPreview } from '@/utils/settings';
import BasicEmpty from '@Components/BasicComponents/BasicEmpty';
import { getStartAndEndTime } from '../../utils/dates';

const buttonStyles = { fontSize: '16px', display: 'flex', alignItems: 'center' };

export default function HighlightedStreamingsTable ({data, loading, select, unselect}) {
	const columns = [
		{
			title: 'Reference ID',
			dataIndex: 'epId',
			key: 'epId',
			width: 300,
		},
		{
			title: 'Title',
			dataIndex: 'title',
			key: 'title',
			style: { wordWrap: 'break-word', wordBreak: 'break-word' }
		},
		{
			title: 'Start and end time',
			key: 'time',
			render: (_, item) => {
				return getStartAndEndTime(item.liveStartDate, item.liveEndDate);
			},
			width: 180,
		},
		{
			width: 200,
			render: (_, element) => (
				<Space size="middle">
					{element.selected ?
						<Button
							style={buttonStyles}
							onClick={() => unselect(element.epId)}
							type="primary"
						>
							<CloseOutlined />
							Unselect
						</Button> :
						<Button
							style={buttonStyles}
							onClick={() => select(element.epId)}
						>
							<CheckOutlined />
							Select
						</Button>
					}
					<Button
						href={getPreview('webstreaming', element.epId)}
						target='_blank'
						style={{paddingInline: 5}}
					>
						<Icon component={ExternalLink} color='black'  />
					</Button>
				</Space>
			),
		},
	];

	return (
		<ConfigProvider renderEmpty={() => BasicEmpty({text:"No results"})}> 
			<Table
				rowKey="key"
				dataSource={data}
				columns={columns}
				loading={loading}
				pagination={false}
			/>
		</ConfigProvider>
	);
}